// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const NamedTypeDefault = {
    enum: (value) => {
        return Object.assign(Object.assign({}, value), { type: "enum", _visit: function (visitor) {
                return FernIr.NamedTypeDefault._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "enum":
                return visitor.enum(value);
            default:
                return visitor._other(value);
        }
    },
};
